import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language.startsWith('en') ? 'es' : 'en';
        i18n.changeLanguage(newLang);
    };

    const currentLang = i18n.language.startsWith('en') ? 'EN' : 'ES';

    return (
        <div className="language-switcher-container">
            <button className="language-switcher-btn" onClick={toggleLanguage}>
                <span className="lang-text">{currentLang}</span>
                <div className="lang-indicator">
                    <span className={currentLang === 'EN' ? 'active' : ''}>🇺🇸</span>
                    <span className="separator">|</span>
                    <span className={currentLang === 'ES' ? 'active' : ''}>🇦🇷</span>
                </div>
            </button>
        </div>
    );
};

export default LanguageSwitcher;
